import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

type Props = {
    labelCol?: boolean;
    isMinimized?: boolean;
    highlightDifferences?: boolean;
    children?: React.ReactNode;
    isStuck?: boolean;
    isHorizontalScroll?: boolean;
};
const defaultProps = {
    labelCol: false,
    isMinimized: false,
    highlightDifferences: false,
    isStuck: false,
    isHorizontalScroll: false,
};

// Link to the 'forwardRef' documentation - 'https://ru.reactjs.org/docs/forwarding-refs.html'
const Cell = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
    const { labelCol, children, isMinimized, highlightDifferences, isStuck, isHorizontalScroll } = props;
    const cellClass = cn({
        [styles.labelColumn]: labelCol,
        [styles.labelColumn_minimized]: isMinimized,
        [styles.labelColumn_highlighted]: highlightDifferences,
        [styles.cell]: true,
        [styles.cell_stuck]: isStuck,
        [styles.labelColumn_scrollShadow]: isHorizontalScroll,
    });

    const cellContentClass = cn({
        [styles.cellContent]: true,
    });

    return (
        <div className={cellClass} ref={ref}>
            <div className={cellContentClass}>{children}</div>
        </div>
    );
});

Cell.defaultProps = defaultProps;

export default Cell;
